import React from "react";
import { useSpring, animated, useInView } from "@react-spring/web";

const AnimatedContent = ({ children, side = "left" }) => {
  const [ref, inView] = useInView({ threshold: 0.5, once: true }); // Adjust the threshold as needed

  const props = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateX(0%)" : `translateX(${side === "right" ? 200 : -200}%)`,
    config: { mass: 2, tension: 200, friction: 60 }
  });

  return (
    <div ref={ref}>
      <animated.div style={props}>{children}</animated.div>
    </div>
  );
};

export default AnimatedContent;
